import React, { Component } from 'react'
import { GrPrice } from '../../../../utilities/helpers'
import { SmartImage } from '../../../../components/SmartImage'
import { Tag } from 'antd-v4'
import { ParkedSaleStore } from './ParkedSaleStore'
import { WarningFilled } from '@ant-design/icons'
import { BundleCartDiscountLine, DiscountTypes } from '@getgreenline/homi-shared'

interface Props {
  bundledDiscount: BundleCartDiscountLine<DiscountTypes>
  parkedSaleStore: ParkedSaleStore
}

export class ParkedSaleBundledDiscount extends Component<Props> {
  render() {
    const { bundledDiscount, parkedSaleStore } = this.props
    const { paymentLines, discountPrice, name, discountId } = bundledDiscount
    return (
      <>
        {paymentLines.map((line) => {
          const { productId, price, productName, sku, inventorySubtracted } = line
          const targetPair = productId ? parkedSaleStore.productPairQueue.get(productId) : null

          return targetPair ? (
            <div
              key={`parkedSalesProductImage_${productId}`}
              className='parked-sales-modal-field-content parked-sales-item'
            >
              <div className='parked-sales-item-image mb-1'>
                <SmartImage src={targetPair.product.imageUrl} width={52} height={52} />
              </div>
              <div className='parked-sales-item-meta'>
                <div className='parked-sales-item-meta-name'>
                  <div>{productName}</div>
                  {sku && <div>SKU: {sku}</div>}
                  <Tag className='ml-0 mb-2'>
                    <span style={{ color: 'black', opacity: 0.65 }}>{name}</span>
                  </Tag>
                </div>
              </div>
              <div className='parked-sales-item-meta-quantity'>
                {`${GrPrice.convertCentToDollar(price)} x ${inventorySubtracted}`}
              </div>
              <div className='parked-sales-item-meta-out-of-stock'>
                {parkedSaleStore.isPaymentQueueLineNegativeInventorySale(
                  targetPair.paymentLine,
                ) && (
                  <div className='out-of-stock-warning'>
                    <WarningFilled />
                    {parkedSaleStore.paymentLineNegativeInventorySaleMessage(
                      targetPair.paymentLine,
                    )}
                  </div>
                )}
              </div>
              <div className='parked-sales-item-meta-total'>
                {`${GrPrice.convertCentToDollar(price)}`}
              </div>
            </div>
          ) : null
        })}
        <div
          key={`parkedSalesProductImage_${discountId}`}
          className='parked-sales-modal-field-content parked-sales-item'
        >
          <div className='parked-sales-item-image'></div>
          <div className='parked-sales-item-meta'>
            <div className='parked-sales-item-meta-name'>
              <p>{name}</p>
            </div>
          </div>
          <div className='parked-sales-item-meta-quantity'>
            {`${GrPrice.convertCentToDollar(discountPrice)} x 1`}
          </div>
          <div className='parked-sales-item-meta-out-of-stock'></div>
          <div className='parked-sales-item-meta-total'>{`${GrPrice.convertCentToDollar(
            discountPrice,
          )}`}</div>
        </div>
      </>
    )
  }
}
